import {
  RECEIVE_FIELDS,
  RECEIVE_FIELDS_FAILURE,
  RECEIVE_FIELDS_MULTI_OPERATIONS,
  RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS,
} from '../constants/actionTypes';

export const initialState = {
  byId: {},
  // List of fields alphabetically ordered
  allIds: [],
  // @TODO: Move logic of current field here, https://climate.jira.com/browse/CFVWEB-1900
  current: '',
};

/**
 * Handles redux state for operations
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function fieldsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_FIELDS_MULTI_OPERATIONS:
    case RECEIVE_FIELDS: {
      let byId = action.payload.reduce(
        (fields, field) => ({ ...fields, [field.id]: field }),
        {}
      );
      byId = { ...state.byId, ...byId };
      const allIds = Object.keys(byId).sort((field1, field2) => {
        if (byId[field1].name < byId[field2].name) {
          return -1;
        }
        if (byId[field1].name > byId[field2].name) {
          return 1;
        }
        return 0;
      });
      return { ...state, byId, allIds };
    }
    case RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS:
    case RECEIVE_FIELDS_FAILURE:
      return initialState;
    default:
      return state;
  }
}

export default fieldsReducer;
